export default __webpack_public_path__ + "static/media/pad-icon.4842125a.svg";